module.exports = __webpack_public_path__ + "media/site/images/products/avisboard-flat-screen@2x-09584d90b66f91217a21256d4e18ad23.png";